import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { addSnackbarSuccess } from '../../modules/notifications/actions';
import messages from './messages';
import Panel from './Panel';

const styles = {
  buttons: {
    '& > button': {
      m: 0,
      ml: 1,
    },
    textAlign: 'right',
    width: {
      lg: '140px',
    },
  },
  errorMessage: {
    color: 'error.main',
    pt: 1,
    textAlign: 'center',
  },
  iconButton: {
    px: 1,
  },
  rfid: {
    overflow: 'hidden',
    width: {
      lg: 'calc(100% - 140px)',
    },
  },
  rfidNormal: {
    fontWeight: 400,
    m: 0,
  },
  rfidSmall: {
    fontSize: 20,
    letterSpacing: 0,
    mt: 1,
  },
  root: {
    background: '#E5ECF0',
    border: '1px solid #CDD9E1',
    display: {
      lg: 'flex',
    },
    my: 2,
    p: 2,
    position: 'relative',
  },
  rootError: {
    borderColor: 'error.main',
  },
};

export interface IPanelRfidProps {
  concealable?: boolean;
  error?: boolean;
  rfidCode: string;
}

export function PanelRfid({ concealable = false, error = false, rfidCode }: IPanelRfidProps) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const [hide, setHide] = useState(concealable);

  const toggleHide = () => {
    setHide(!hide);
  };

  const onCopyToClipboard = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (rfidCode && copy(rfidCode)) {
      dispatch(addSnackbarSuccess(messages.userAccessFormRfidCopied));
    }
  };

  return (
    <Panel errorMessage={formatMessage(messages.userAccessFormRfidErrorMessage)} isError={error}>
      <Box sx={styles.rfid}>
        <Typography sx={[styles.rfidNormal, rfidCode?.length > 6 ? styles.rfidSmall : {}]} variant="h4">
          {hide ? ''.padEnd(rfidCode.length, '#') : rfidCode}
        </Typography>
      </Box>
      <Box sx={styles.buttons}>
        {concealable && (
          <IconButton onClick={toggleHide} sx={styles.iconButton}>
            {hide ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
          </IconButton>
        )}
        <Button disabled={!rfidCode} onClick={onCopyToClipboard} startIcon={<FileCopyOutlinedIcon />}>
          <FormattedMessage {...messages.userAccessFormRfidCopy} />
        </Button>
      </Box>
    </Panel>
  );
}
